import Constant from "@/common/constant/Constant";
import Utils from "@/common/utils/utils";
import { I18n } from "aws-amplify";
import { useEffect } from "react";
import EmailInputText from './EmailInputText';
import EmailMultiChoiceInput from './EmailMultiChoiceInput';
import EmailRichtext from './EmailRichtext';

function EmailResponseSetting({
    corporationDetail,
    isEmailResponseSettingFunction,
    setIsEmailResponseSettingFunction,
    projectMail,
    setProjectMail,
    projectAddressName,
    setProjectAddressName,
    senderEmailAddress,
    setSenderEmailAddress,
    ccEmailAddressList,
    setCcEmailAddressList,
    bccEmailAddressList,
    setBccEmailAddressList,
    signature,
    setSignature,

    setIsEdited,
    setError,
    listSuggestSearchEmail,
    ...props
}) {
    const mailSettingDefault = {...props}.mailSettingDefault

    // handle onchange emailResponseSettingData
    useEffect(() => {
        const isError = 
            !Utils.isEmptyString(projectMail.error) ||
            !Utils.isEmptyString(projectAddressName.error) ||
            !Utils.isEmptyString(senderEmailAddress.error) ||
            !Utils.isEmptyString(signature.error);

        if (isEmailResponseSettingFunction) { // only validate when ON setting
            const isEmptyMailOrAddress =
                Utils.isEmptyString(projectMail.value) ||
                Utils.isEmptyString(projectAddressName.value);

            setError(prev => {
                if (isEmptyMailOrAddress || isError) {
                    return {...prev, emailResponseSetting: 'error'}
                }
                
                delete prev.emailResponseSetting
                return prev
            })
        } else {
            if (isError) {
                setProjectMail(prev => ({...prev, error: ''}))
                setProjectAddressName(prev => ({...prev, error: ''}))
                setSenderEmailAddress(prev => ({...prev, error: ''}))
                setSignature(prev => ({...prev, error: ''}))
            }
        }
    }, [isEmailResponseSettingFunction, projectMail, projectAddressName, senderEmailAddress, ccEmailAddressList, bccEmailAddressList, signature]);
    

    return ( 
        <div className="groupSetting category-active">
            <div className="advanced-setting-title">
                <h3>{I18n.get('EMAIL_RESPONSE_SETTING')}</h3>
            </div>
            <div className="project-email-setting-group email-setting-function">
                <div className="title-name">
                    {I18n.get('EMAIL_RESPONSE_SETTING_FUNCTION')}
                </div>
                <div className="switch-check">
                    <input
                        name="isEmailResponseSettingFunction"
                        id="is-email-response-setting-function-switch-id"
                        type="checkbox"
                        checked={isEmailResponseSettingFunction}
                        onChange={e => {
                            setIsEmailResponseSettingFunction(!isEmailResponseSettingFunction);
                            setProjectMail(prev => ({
                                ...prev,
                                value: mailSettingDefault?.projectMail
                            }));
                            setProjectAddressName(prev => ({
                                ...prev,
                                value: mailSettingDefault?.projectAddressName
                            }));
                            setSenderEmailAddress(prev => ({
                                ...prev,
                                value: mailSettingDefault?.senderEmailAddress
                            }));
                            setCcEmailAddressList([...mailSettingDefault.ccEmailAddressList]);
                            setBccEmailAddressList([...mailSettingDefault.bccEmailAddressList]);
                            setSignature(prev => ({
                                ...prev,
                                value: mailSettingDefault?.signature
                            }));
                            if (isEmailResponseSettingFunction) {
                                setError(prev => {
                                    delete prev.emailResponseSetting;
                                    return prev
                                })
                            };
                            setIsEdited(true)
                        }}
                    />
                    <label htmlFor="is-email-response-setting-function-switch-id"></label>
                </div>
            </div>
            <EmailInputText
                label={I18n.get('PROJECT_EMAIL_ADDRESS')}
                emailValue={projectMail}
                setEmailValue={setProjectMail}
                required={true}
                disable={!isEmailResponseSettingFunction}
                fixedDomain={`@${corporationDetail.organizationDomain}.${Utils.getEmailDomain()}`}
                setIsEdited={setIsEdited}
            />
            <EmailInputText
                label={I18n.get('PROJECT_EMAIL_ADDRESS_NAME')}
                emailValue={projectAddressName}
                setEmailValue={setProjectAddressName}
                required={true}
                disable={!isEmailResponseSettingFunction}
                setIsEdited={setIsEdited}
                isEmailInput={false}
            />
            <EmailInputText
                label={I18n.get('EMAIL_ADDRESS_TO_USE_AS_THE_SENDER')}
                emailValue={senderEmailAddress}
                setEmailValue={setSenderEmailAddress}
                disable={!isEmailResponseSettingFunction}
                setIsEdited={setIsEdited}
                instruction={I18n
                        .get('EMAIL_ADDRESS_TO_USE_AS_THE_SENDER_MESSAGE')
                        .replace(
                            '{{project_email_address}}',
                            !Utils.isEmptyString(projectMail.value)
                                ? `${projectMail.value}@${corporationDetail.organizationDomain}.${Utils.getEmailDomain()}`
                                : ''
                        )
                }
            />
            {/* ALWAYS_INCLUDE_CC_EMAIL_ADDRESS */}
            <div className="project-email-setting-group">
                <div className="embeddedCode-label margin-bottom-5">
                    <span>{I18n.get('ALWAYS_INCLUDE_CC_EMAIL_ADDRESS')}</span>
                </div>
                <div className="email-response-address-input-wrap">
                    <EmailMultiChoiceInput
                        disable={!isEmailResponseSettingFunction}
                        addressList={ccEmailAddressList}
                        setAddressList={setCcEmailAddressList}
                        setIsEdited={setIsEdited}
                        listSuggestSearchEmail={listSuggestSearchEmail}
                    />
                </div>
            </div>
            {/* ALWAYS_INCLUDE_BCC_EMAIL_ADDRESS */}
            <div className="project-email-setting-group">
                <div className="embeddedCode-label margin-bottom-5">
                    <span>{I18n.get('ALWAYS_INCLUDE_BCC_EMAIL_ADDRESS')}</span>
                </div>
                <div className="email-response-address-input-wrap">
                    <EmailMultiChoiceInput
                        disable={!isEmailResponseSettingFunction}
                        addressList={bccEmailAddressList}
                        setAddressList={setBccEmailAddressList}
                        setIsEdited={setIsEdited}
                        listSuggestSearchEmail={listSuggestSearchEmail}
                    />
                </div>
            </div>
            <EmailRichtext
                label={I18n.get('SIGNATURE')}
                disable={!isEmailResponseSettingFunction}
                richtextValue={signature}
                setRichtextValue={setSignature}
                setIsEdited={setIsEdited}
                isValidateWhenBlur={true}
            />
        </div>
     );
}

export default EmailResponseSetting;
